import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2l-8 4l8 4l8 -4l-8 -4","key":"svg-0"}],["path",{"d":"M4 10l8 4l8 -4","key":"svg-1"}],["path",{"d":"M4 18l8 4l8 -4","key":"svg-2"}],["path",{"d":"M4 14l8 4l8 -4","key":"svg-3"}]]

const IconStack3 = createReactComponent('outline', 'stack-3', 'Stack3', __iconNode);

export default IconStack3;